import { render, staticRenderFns } from "./bannerMain.vue?vue&type=template&id=8a3af860&"
import script from "./bannerMain.vue?vue&type=script&lang=js&"
export * from "./bannerMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports